import { useInstrumentosUtilizaveis } from '../../hooks/useInstrumentos'

interface Props {
  value: string | null
  onChange: (id: string | null) => void
  disabled?: boolean
  testId?: string
}

const PREFIXO_OBSERVACAO = '[instrumento:'

/**
 * Extrai o id do instrumento de uma observação no formato `[instrumento:UUID] obs livre`.
 * Retorna [id, restoObs] — id pode ser null.
 */
export function parseObservacaoComInstrumento(obs: string): [string | null, string] {
  if (!obs.startsWith(PREFIXO_OBSERVACAO)) return [null, obs]
  const fim = obs.indexOf(']')
  if (fim < 0) return [null, obs]
  const id = obs.slice(PREFIXO_OBSERVACAO.length, fim)
  const resto = obs.slice(fim + 1).trimStart()
  return [id, resto]
}

export function buildObservacaoComInstrumento(
  instrumentoId: string | null,
  observacaoLivre: string,
): string {
  if (!instrumentoId) return observacaoLivre
  return `[instrumento:${instrumentoId}] ${observacaoLivre}`.trimEnd()
}

export default function InstrumentoSelector({ value, onChange, disabled, testId }: Props) {
  const list = useInstrumentosUtilizaveis()

  return (
    <select
      data-testid={testId}
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value || null)}
      disabled={disabled || list.isLoading}
      style={{
        padding: '0.3rem',
        fontSize: '0.85rem',
        minWidth: '160px',
        background: '#FAFAFA',
      }}
    >
      <option value="">— sem instrumento —</option>
      {list.data?.map((i) => (
        <option key={i.id} value={i.id}>
          {i.tipo_display} • {i.marca} {i.modelo} (S/N {i.numero_serie})
        </option>
      ))}
    </select>
  )
}
